export default __webpack_public_path__ + "static/about-header-eb5e651be1bd3eae19a4628ddc81f915.jpg";